import ProjectHeroMusicPlayerApp from "../../../components/ProjectHero/MusicPlayerApp/ProjectHeroMusicPlayerApp";
import ProjectDetailsMusicPlayerApp from "../../../components/ProjectDetails/MusicPlayerApp/ProjectDetailsMusicPlayerApp";

function ProjectPageMusicPlayerApp() {
  return (
    <>
      <ProjectHeroMusicPlayerApp />
      <ProjectDetailsMusicPlayerApp />
    </>
  );
}

export default ProjectPageMusicPlayerApp;
